/**
 * @Author: Kerem Koç <keremkoc>
 * @Date:   2018-02-26T02:19:15+03:00
 * @Email:  kerem@kocapps.com
 * @Filename: correct.js
 * @Last modified by:   keremkoc
 * @Last modified time: 2018-02-28T23:27:46+03:00
 */

(function($, root) {

  window.rdo.languageSelector = {
    link: $('#menu-item-9999999999 > a'),
    sub: $('#menu-item-9999999999 > .sub-menu')
  }

  $.correct = function() {
    window.rdo.languageSelector.link.attr('href', '').addClass('language-selector');
  }

  window.rdo.languageSelector.link.click(function(e) {
    e.preventDefault();
    $(this).parent().toggleClass('active');
    // window.rdo.languageSelector.sub.fadeIn();
  });

  $(function() {
    'use strict';

    //products listing pagename
    //correct left menu's parent item
    //activate parent if child is selected:

    var activate_parent = $('.product-solutions .sub-solution .active');
    if (activate_parent.length) {
      $('#' + activate_parent.attr('data-active-parent')).addClass('active');
    }

    //main menu corrections:
    //if it is a solution page (displayed as product list), activate solutions in the top menu
    // var body_is_solutions = $('body.single-solutions');
    // if (body_is_solutions.length) {
    //   window.rdo.menuItems.products.addClass('current-menu-ancestor');
    // }
    var currentnavitemname = $('input#current-nav');
    if (currentnavitemname.length) {
      var currentnavitem = window.rdo.menuItems[currentnavitemname.val()];
      $('#navbar .current-menu-ancestor').removeClass('current-menu-ancestor');
      $('#navbar .current-menu-item').removeClass('current-menu-item');
      $(currentnavitem).addClass('current-menu-ancestor');

    }

  });

})(jQuery, this);
